
/* ------------------------------------------------
アコーディオン
------------------------------------------------ */
class Accordion {
  constructor(accordionElement) {
    this.accordionElement = accordionElement;
    this.buttonElement = accordionElement.querySelector(".js-accordion__trigger");
    this.contentElement = accordionElement.querySelector(".js-accordion__content");
    this.isOpen = this.accordionElement.classList.contains("is-active");

    this.buttonElement.addEventListener("click", () => {
      this.toggleAccordion();
    });

    // 初期状態で is-active が付いている場合に開いた状態にする
    if (this.isOpen) {
      this.contentElement.style.maxHeight = this.contentElement.scrollHeight + "px";
    }
  }

  toggleAccordion() {
    this.isOpen = !this.isOpen;
    this.accordionElement.classList.toggle("is-active", this.isOpen);
    if (this.isOpen) {
      this.contentElement.style.maxHeight = this.contentElement.scrollHeight + "px";
    } else {
      this.contentElement.style.maxHeight = null;
    }
  }
}
function initializeAccordions() {
  const accordions = document.querySelectorAll(".js-accordion");
  accordions.forEach(accordionElement => {
    new Accordion(accordionElement);
  });
}


/* ---------------------------------------------------------------------
DOMContentLoaded
--------------------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', () => {
  initializeAccordions();
}, false);



/* ---------------------------------------------------------------------
shopify:section:load
--------------------------------------------------------------------- */
document.addEventListener('shopify:section:load', () => {
  initializeAccordions();
}, false);



/* ---------------------------------------------------------------------
resize
--------------------------------------------------------------------- */

let currentWidth = window.innerWidth;
let resizeTimer = null;

window.addEventListener('resize', () => {
  if (currentWidth === window.innerWidth) return;
  if (resizeTimer) {
    clearTimeout(resizeTimer);
  }
  resizeTimer = setTimeout(() => {
    currentWidth = window.innerWidth;
  }, 200);
});


